// import ajax from "./ajax.js"
import ajax from "./ajaxGateWay.js"
import * as tools from './tools.js'

var common = {
  ajax: ajax,
};

Object.assign(common,tools);

window.common = common;



//////////////////
// WEBPACK FOOTER
// ./static/js/index.js
// module id = null
// module chunks = 